const ENSports = [
    {
        title: 'Longing for a return to "normalcy" in Philadelphia pro sports',
        description: 'While it’s still possible that too many positive tests in Major League Baseball, the National Basketball Association and the National Hockey League might prevent some or all of them from completing their seasons, how wonderful would it be to enjoy something approaching a return to normalcy?',
        url: 'https://eu.courierpostonline.com/story/sports/2020/06/29/moore-longing-for-rsquoreturn-to-normalcyrsquo-in-philly-pro-sports/3281112001/',
        image: 'https://www.gannett-cdn.com/media/2020/06/29/USATODAY/usatsports/ghows-PA-200629086-e3b7527d.jpg?width=1080&quality=50',
        publishedAt: "2020-06-26T18:20:00Z",
        source: {
            name: 'Courier Post',
            url: 'https://eu.courierpostonline.com'
        }
    },
    {
        title: 'What sports have restarted and when will the rest follow?',
        description: 'The coronavirus crisis has played havoc with the sporting calendar since March, but slowly things are returning to normal.',
        url: 'https://www.bt.com/sport/news/what-sports-have-restarted-and-when-will-the-rest-follow0',
        image: 'https://content.assets.pressassociation.io/2020/06/29163550/5b95b5bc-7131-4f89-afd0-25f6268996ae.jpg?rect=0,85,2000,1125&ext=.jpg&w=764&h=430',
        publishedAt: "2020-06-25T15:20:00Z",
        source: {
            name: 'BT',
            url: 'https://www.bt.com'
        }
    },
    {
        title: 'For not the first time, sports has helped Mississippians see their way to change',
        description: 'Sports have never been only a game in Mississippi. No, sports are woven deeply into our cultural fabric, a major part of who we are and what we are about. Always have been.',
        url: 'https://mississippitoday.org/2020/06/29/for-not-the-first-time-sports-has-helped-mississippians-see-their-way-to-change/',
        image: 'https://mississippitoday.org/wp-content/uploads/2020/06/PENSON--771x514.jpg',
        publishedAt: "2020-06-28T14:40:00Z",
        source: {
            name: 'Mississippi Today',
            url: 'https://mississippitoday.org/'
        }
    },
    {
        title: 'Craig Levein: Ex-Hearts boss says sports scientists too powerful',
        description: 'There is a "growing feeling" that sports scientists now wield too much power among Scottish clubs, says former Hearts manager Craig Levein.',
        url: 'https://www.bbc.com/sport/football/53222396',
        image: 'https://ichef.bbci.co.uk/onesport/cps/800/cpsprodpb/11D5E/production/_113145037_gettyimages-51919766.jpg',
        publishedAt: "2020-06-22T12:30:00Z",
        source: {
            name: 'BBC',
            url: 'https://www.bbc.com'
        }
    },
    {
        title: 'Social justice messages to feature on NBA players’ jerseys in 2020',
        description: 'The NBA will follow the lead of the English Premier League in allowing players to have a social justice message on the back of their jerseys when the season restarts, according to reports.',
        url: 'https://7news.com.au/sport/basketball/social-justice-messages-to-feature-on-nba-players-jerseys-in-2020-c-1130979',
        image: 'https://images.s.7news.com.au/publication/C-1130979/3bb0bf9e1e1db9582be445feb11742f68591dbc7-16x9-x0y0w1280h720.jpg?imwidth=828&impolicy=sevennews_v2',
        publishedAt: "2020-06-27T17:20:00Z",
        source: {
            name: '7news',
            url: 'https://7news.com.au'
        }
    },
    {
        title: '5% of NBA Players Test Positive for the Virus',
        description: 'Tests showed that 16 of 302 players were positive in the league’s first round of coronavirus testing before the NBA attempts to restart in July.',
        url: 'https://www.wsj.com/articles/5-of-nba-players-test-positive-for-the-virus-11593191061',
        image: 'https://m.wsj.net/video/20200506/clearancevirus/clearancevirus_960x540.jpg',
        publishedAt: "2020-06-28T11:20:00Z",
        source: {
            name: 'The Wall Street Journal',
            url: 'https://www.wsj.com'
        }
    },
    {
        title: 'The Premier League returns - all you need to know',
        description: 'The Premier League returns on Wednesday... but not exactly as we know it.',
        url: 'https://www.bbc.com/sport/football/53009593',
        image: 'https://ichef.bbci.co.uk/onesport/cps/800/cpsprodpb/13064/production/_112942977_index.jpg',
        publishedAt: "2020-06-29T19:40:00Z",
        source: {
            name: 'BBC',
            url: 'https://www.bbc.com'
        }
    },
    {
        title: 'Bruce wants clarity from English Premier League on proposed Newcastle takeover',
        description: 'Newcastle United manager Steve Bruce wants “clarity” from the Premier League on the proposed Saudi-backed takeover of the club as he says the delay in approving the deal is “not healthy for anybody”.',
        url: 'https://www.malaymail.com/news/sports/2020/06/29/bruce-wants-clarity-from-english-premier-league-on-proposed-newcastle-takeo/1879786',
        image: 'https://media.malaymail.com/uploads/articles/2020/2020-06/Steve_BRUCE_19062020.JPG',
        publishedAt: "2020-06-26T11:20:00Z",
        source: {
            name: 'Malay Mail',
            url: 'https://www.malaymail.com'
        }
    },
    {
        title: 'Majority of Canadian university sports canceled until winter 2021',
        description: 'U Sports, the national brand of university sports in Canada, has decided to cancel six of its national championships for the 2020 fall season, according to a press release from the league on Monday afternoon.',
        url: 'https://www.rcinet.ca/en/2020/06/08/majority-of-canadian-university-sports-canceled-until-winter-2021/',
        image: 'https://www.rcinet.ca/en/wp-content/uploads/sites/3/2020/06/unnamed423432-635x357.jpg',
        publishedAt: "2020-06-24T21:20:00Z",
        source: {
            name: 'RCI',
            url: 'https://www.rcinet.ca'
        }
    },
    {
        title: 'Love of Sports Connects Father & Daughter',
        description: 'Before coronavirus concerns moved much of his side-business as a personal trainer online, Thamar Davis’s clients often got a package deal when they turned up at the gym.',
        url: 'https://www.voanews.com/usa/love-sports-connects-father-daughter',
        image: 'https://im-media.voltron.voanews.com/Drupal/01live-166/styles/sourced/s3/2020-06/F%26D%2014.jpg?itok=iUhUgTs5',
        publishedAt: "2020-06-21T17:20:00Z",
        source: {
            name: 'VOA',
            url: 'https://www.voanews.com'
        }
    },
    {
        title: 'Whitmer cautions about return of pro sports: "We’re going to watch it differently"',
        description: 'Michigan Gov. Gretchen Whitmer signed an executive order late last week that allows for the return of professional sports in the state. But she sounded a cautionary note while discussing that decision.',
        url: 'https://eu.detroitnews.com/story/sports/mlb/tigers/2020/06/29/gretchen-whitmer-michigan-professional-sports-were-going-watch-differently/3279061001/',
        image: 'https://www.gannett-cdn.com/presto/2020/06/29/PDTN/97f08f33-e70b-4df4-a1be-62908be0b63c-tigfans.jpg?width=1080&quality=50',
        publishedAt: "2020-06-26T18:50:00Z",
        source: {
            name: 'Detroit News',
            url: 'https://eu.detroitnews.com'
        }
    },
    {
        title: 'Arjen Robben: Michael Jordan documentary inspired Groningen comeback',
        description: 'Arjen Robben was inspired to launch a comeback with Groningen after they showed him a montage of basketball great Michael Jordan’s career.',
        url: 'https://www.bbc.com/sport/football/53205616',
        image: 'https://ichef.bbci.co.uk/onesport/cps/800/cpsprodpb/3B58/production/_113129151_robben_getty.jpg',
        publishedAt: "2020-06-23T13:20:00Z",
        source: {
            name: 'BBC',
            url: 'https://www.bbc.com'
        }
    },
    {
        title: 'Juventus’ Miralem Pjanic and Barcelona’s Arthur in swap deal',
        description: 'Juventus midfielder Miralem Pjanic will join Barcelona at the end of the season in a swap deal with Brazil international Arthur.',
        url: 'https://www.bbc.com/sport/football/53224875',
        image: 'https://ichef.bbci.co.uk/onesport/cps/800/cpsprodpb/0311/production/_113158700_pjanictwo_getty.jpg',
        publishedAt: "2020-06-24T11:20:00Z",
        source: {
            name: 'BBC',
            url: 'https://www.bbc.com'
        }
    },
    {
        title: 'Patriots sign quarterback Cam Newton to 1-year deal',
        description: 'Former Panthers pivot would replace 6-time Super Bowl champion Tom Brady',
        url: 'https://www.cbc.ca/sports/football/nfl/mfl-new-england-patriots-sign-cam-newton-1.5630809',
        image: 'https://i.cbc.ca/1.5630812.1593442862!/fileImage/httpImage/image.jpg_gen/derivatives/16x9_780/1174328871.jpg',
        publishedAt: "2020-06-29T18:30:00Z",
        source: {
            name: 'CBC',
            url: 'https://www.cbc.ca'
        }
    },
    {
        title: 'Patriots lose third-round draft pick, $1 million in fines for filming Bengals coaching staff',
        description: 'The NFL has hit the New England Patriots with multiple sanctions for filming the Cincinnati Bengals coaching staff near the end of last season.',
        url: 'https://sports.yahoo.com/patriots-lose-thirdround-draft-pick-more-than-1-million-in-fines-for-filming-bengals-coaching-staff-003129454.html?guccounter=1&guce_referrer=aHR0cHM6Ly93d3cuZ29vZ2xlLmNvbS8&guce_referrer_sig=AQAAAC7_1LxGh8qi4RVCk3uMAg2zCnj49yUpfV3Jn_oeMqMjh3wCpRZwVjqZgVYugSZN-OWk3n5-BGid0xFTqo9zt7B4ZyaWOlsYdB_NCGmmf7tgyUeOPlY5p2Hm4dvMSl_vkBXsyFUXnIUaj3Ul1d-whs9rYp_XjejdSEQ5ukJmsL1A',
        image: 'https://s.yimg.com/ny/api/res/1.2/0K8sVBqhbmMGvBmZmY.yOA--~A/YXBwaWQ9aGlnaGxhbmRlcjtzbT0xO3c9ODAw/https://media-mbst-pub-ue1.s3.amazonaws.com/creatr-images/2020-06/7539ead0-b99f-11ea-beef-2b3cda3db474',
        publishedAt: "2020-06-26T11:20:00Z",
        source: {
            name: 'Yahoo',
            url: 'https://sports.yahoo.com'
        }
    },
    {
        title: 'Brown University student-athletes fight for reinstatement of varsity sports',
        description: 'More than 100 students across 8 sports were told their varsity teams are being eliminated',
        url: 'https://www.foxbusiness.com/sports/brown-university-student-athletes-varsity-sports-cancel',
        image: 'https://a57.foxnews.com/static.foxbusiness.com/foxbusiness.com/content/uploads/2020/06/720/405/alexa-jacobs-brown-university-squash-e1593349647811.jpg?ve=1&tl=1',
        publishedAt: "2020-06-27T18:40:00Z",
        source: {
            name: 'Fox',
            url: 'https://www.foxbusiness.com'
        }
    },
    {
        title: 'Akron Children’s Hospital in Warren offers sports physicals',
        description: 'High school athletes can get the OHSAA requirement fulfilled through Oct. 30.',
        url: 'https://www.mahoningmatters.com/local-news/akron-childrens-hospital-in-warren-offers-sports-physicals-2521497',
        image: 'https://www.vmcdn.ca/f/files/shared/feeds/global/2020/03/doctor.jpg;w=960',
        publishedAt: "2020-06-29T11:30:00Z",
        source: {
            name: 'Mahoning Matters',
            url: 'https://www.mahoningmatters.com'
        }
    },
    {
        title: 'FA Cup semi-final draw: Manchester United to face Chelsea',
        description: 'Manchester United will face Chelsea and Arsenal will play holders Manchester City in the semi-finals of the FA Cup.',
        url: 'https://www.bbc.com/sport/football/53214835',
        image: 'https://ichef.bbci.co.uk/onesport/cps/800/cpsprodpb/155BB/production/_113138478_gettyimages-1144895082.jpg',
        publishedAt: "2020-06-26T13:20:00Z",
        source: {
            name: 'BBC',
            url: 'https://www.bbc.com'
        }
    },
    {
        title: 'Yahoo Sports Unveils Fantasy Baseball Plans For Shortened MLB Season',
        description: 'Yahoo Sports released its plans Sunday to adjust various league formats for its popular fantasy baseball platform for the shortened, 60-game Major League Baseball season in 2020 that’s scheduled to begin on July 23.',
        url: 'https://www.forbes.com/sites/shlomosprung/2020/06/28/yahoo-sports-fantasy-baseball-2020-mlb-season-coronavirus-pandemic/#3a3e737d5a5e',
        image: 'https://specials-images.forbesimg.com/imageserve/5ef8b8baaccb250006e7c32e/960x0.jpg?fit=scale',
        publishedAt: "2020-06-21T10:10:00Z",
        source: {
            name: 'Forbes',
            url: 'https://www.forbes.com'
        }
    },
    {
        title: 'Tyreek Hill says he’s ready to race anyone in the NFL',
        description: 'The challenge comes on the heels of multiple talking heads across the league arguing that someone other than Hill may, in fact, be the fastest player in the league.',
        url: 'https://arrowheadaddict.com/2020/06/29/tyreek-hill-challenge-race-anyone-nfl-chiefs-fastest-player/',
        image: 'https://images2.minutemediacdn.com/image/fetch/w_850,h_560,c_fill,g_auto,f_auto/https%3A%2F%2Farrowheadaddict.com%2Fwp-content%2Fuploads%2Fgetty-images%2F2018%2F08%2F1183857275-850x560.jpeg',
        publishedAt: "2020-06-27T17:20:00Z",
        source: {
            name: 'Arrowhead Addict',
            url: 'https://arrowheadaddict.com'
        }
    }
]

export default ENSports;